import {
  instance as axios
} from './config.js';
import {
  store
} from '@/store/index.js';

export const api = {
  //#region Zelic
  async checkNewwMessages(taskID) {
    if (!taskID) return;
    return await axios.get(`tasks/${taskID}/unseenfeeds`);
  },

  async searchStepFeeds(taskID, stp_time_created, type) {
    if (!taskID) return;
    return await axios.get(`tasks/${taskID}/feeds`, {
      params: {
        time: stp_time_created,
        pravac: "start",
        type: type,
      }
    });
  },

  async setFeedImportant(fed_id, important) {
    return await axios.post(`feeds/${fed_id}`, {
      important: important,
    });
  },
  async getUserInfo() {
    return await axios.get(`auth/users`);
  },
  async createTask(title, description, deadline, tagarray, userarray, priorety, pro_id) {
    return await axios.post(`tasks`, {
      type: 'task',
      proid: pro_id,
      title: title,
      description: description,
      deadline: deadline,
      tagarray: JSON.stringify(tagarray),
      usersarray: JSON.stringify(userarray),
      priority: priorety,
    });

  },
  async createTimestamps(taskID, time_created, title, order) {
    if (!taskID) return;
    return await axios.post(`tasks/${taskID}/feeds`, {
      timecreated: time_created,
      text: title,
      type: "text",
      islabel: 1,
      fedorder: order,
    });
  },
  // koristi se u TaskAdd.vue, TaskAdd.vue
  async suggestGroup(grpType, searchStr, comId) {
    return await axios.get('groups', {
      params: {
        searchstring: searchStr,
        comid: comId,
        type: grpType,
        belongs: 'yes'
      }
    });

  },
  // Koristi se u TaskAdd.vue
  async suggestTags(pro_id, tagFor, searchStr) {
    return await axios.get(`projects/${pro_id}/tags`, {
      params: {
        searchstring: searchStr,
        type: tagFor,
      }
    });
  },
  async refreshSuggestions(searchText, pro_id) {
    return await axios.get('users', {
      params: {
        searchstring: searchText,
        proid: pro_id,
      }
    });
  },
  //#endregion
  //#region Feeds
  async deleteTImestamp(taskID, stm_id) {
    if (!taskID) return;
    return await axios.delete(`tasks/${taskID}/labels/${stm_id}`);
  },

  async readeTimestemps(taskID) {
    if (!taskID) return;
    return await axios.get(`tasks/${taskID}/labels`);
  },
  async readeFeeds(taskID, fedid, direction, type, searchingstring, fed_important, fed_time, impbyoth) {
    if (!taskID) return;
    return await axios.get(`/tasks/${taskID}/feeds`, {
      params: {
        fedid: fedid,
        pravac: direction,
        type: type,
        searchstring: searchingstring,
        fed_important: fed_important,
        fedtime: fed_time,
        impbyoth: impbyoth
      }
    });

  },
  async readeGloablFeeds(offset, type, searchingstring, fed_important, impbyoth) {
    return await axios.get('users/feeds', {
      params: {
        type: type,
        searchstring: searchingstring,
        fed_important: fed_important,
        offset: offset,
        count: false,
        impbyoth: impbyoth,
      }
    });
  },
  postMessage(taskID, mess) {
    // var msg = store.state.messages;
    var fd = new FormData();
    fd.append('type', 'text');
    fd.append('text', mess);
    return axios.post(`/tasks/${taskID}/feeds`, fd);
  },
  sendAttach(taskID, fd, config) {
    return axios.post(`/tasks/${taskID}/feeds`, fd, config);
  },
  //#endregion
  //#region Zex

  // AUTH
  async sessionActive() {
    try {
      let res = await axios.get(`auth/users`);
      let statusOK = res.data.status === 'OK';
      if (statusOK) {
        localStorage.name = res.data.name;
        localStorage.surname = res.data.surname;
        localStorage.email = res.data.email;
        localStorage.emailNotif = res.data.getemail;
        store.commit("localStorage", {
          name: localStorage.name,
          surname: localStorage.surname,
          email: localStorage.email,
          emailNotif: localStorage.emailNotif
        });
        return true;
      }
    } catch (e) {
      console.log(e);
    }
    return false;
  },
  login(email, password) {
    return axios.post('auth/login', {
      email: email,
      pass: password
    });
  },
  register(user) {
    return axios.post('auth/singup', {
      email: user.email,
      pass: user.password,
      name: user.name,
      surname: user.surname
    });
  },
  async getProjects() {
    return await axios.get('projects');

  },
  async getProjectFromTaskID(taskID) {
    if (!taskID) return;
    return await axios.get(`tasks/${taskID}/project`);
  },
  async getProjectInfo(selID) {
    return await axios
      .get(`projects/${selID}`);

  },
  async getTasks(params) {
    return await axios.get('/users/tasks', {
      params: {
        pro_id: params.pro_id,
        created: params.created,
        assigned: params.assigned,
        archived: params.archived,
        searchstr: params.searchstr,
        tagarray: JSON.stringify(params.tagarray),
      }
    });
  },
  async getFeedCount() {
    return await axios.get('/users/feeds', {
      params: {
        count: true
      }
    });
  },
  async getTagSuggestions(proID, query, type) {
    return await axios.get(`projects/${proID}/tags`, {
      params: {
        searchstring: query,
        type: type,
      }
    });
  },
  async hasAvatar() {
    return await axios.get(`auth/users/hasimage`);

  },
  async getAvatar(link) {
    return await axios.get(link);

  },
  deleteAvatar() {
    return axios.delete('auth/users/img');
  },
  async editUserAvatar(fd) {
    return await axios.put(`auth/users/img`, fd, {
      headers: {
        "content-type": "multipart/form-data"
      }
    });
  },
  async editUserOptions(tableData) {
    return await axios.put("auth/users", {
      name: tableData[0].value,
      surname: tableData[1].value,
      email: tableData[2].value,
      pass: tableData[3].value,
      getemail: tableData[4],
    });
  },
  async editProject(project, deadlineParsed, usersString, selID, tagarray) {
    return await axios
      .put(`projects/${selID}`, {
        name: project.title,
        description: project.description,
        deadline: deadlineParsed,
        usersarray: usersString,
        tagarray: JSON.stringify(tagarray),
      });
  },
  async createProject(project, deadlineParsed, usersString, tagarray) {
    return await axios
      .post("projects", {
        name: project.title,
        description: project.description,
        deadline: deadlineParsed,
        usersarray: usersString,
        tagarray: JSON.stringify(tagarray),
      });
  },
  //#endregion
  //#region Milos
  async editTask(taskID, title, description, deadline, tagarray, userarray, priority) {
    if (!taskID) return;
    return await axios.put(`tasks/${taskID}`, {
      title: title,
      description: description,
      deadline: deadline,
      tagarray: tagarray,
      usersarray: userarray,
      priority: priority
    });
  },
  async loadTaskInfo(taskID) {
    if (!taskID) return;
    return await axios.get(`tasks/${taskID}`);
  },
  async loadTags(proid, searchstring) {
    return await axios.get(`projects/${proid}/tags`, {
      params: {
        type: "task",
        searchstring: searchstring,
      }
    });
  },

  async changeTaskStatus(parameter, taskID) {
    return await axios.put(`tasks/${taskID}/status`, {
      status: parameter,
    });
  },

  async dragAndDropUpload(task, formData, config) {
    return await axios.post(`tasks/${task}/feeds`, formData, config);
  },

  async getSingleProjectInfo(proid) {
    return await axios.get(`projects/${proid}`);
  },

  async getProjectUsers(proid) {
    return await axios.get(`projects/${proid}/users`);
  },

  async getProjectTags(proid) {
    return await axios.get(`projects/${proid}/alltags`);
  }
  //#endregion
};



// WEBPACK FOOTER //
// ./src/api/index.js